import { CustomTableConfig } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { getBasicColumnConfig } from 'core/utils/format-table-cell';
import { formatListField } from 'core/utils/format-table-cell/format-table-cell';
import { EditableColumn } from 'modules/global/model';
import {
    PredefinedComment,
    PredefinedCommentDeviceType,
} from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/predefined-comments.model';

export const useDefaultConfigPredefinedCommentsList = () => {
    const { t } = useTranslation();

    const getHeaderColumn = (column: string) => `settings.devices.predefined-comments.columns.${column}`;

    const getColumnsToShow = (): EditableColumn[] => [
        {
            field: 'commentText',
            text: t('settings.devices.predefined-comments.columns.commentText'),
            visible: true,
            pinned: false,
            columnIndex: 0,
        },
        {
            field: 'deviceTypes',
            text: t('settings.devices.predefined-comments.columns.deviceTypes'),
            visible: true,
            pinned: false,
            columnIndex: 1,
        },
        {
            field: 'active',
            text: t('settings.devices.predefined-comments.columns.status'),
            visible: true,
            pinned: false,
            columnIndex: 2,
        },
    ];

    const getDefaultConfig = (): CustomTableConfig<PredefinedComment> => ({
        entity: 'predefinedComment',
        columnsToShow: getColumnsToShow(),
        fields: [
            getBasicColumnConfig(t, getHeaderColumn, 'commentText', false),
            {
                name: 'deviceTypes',
                headerOptions: {
                    text: t(getHeaderColumn('deviceTypes')),
                },
                rowOptions: {
                    cellOptions: {
                        format: (item: PredefinedComment) =>
                            formatListField<PredefinedCommentDeviceType>(item.deviceTypes),
                    },
                },
            },
            {
                name: 'active',
                headerOptions: {
                    text: t(getHeaderColumn('status')),
                },
                rowOptions: {
                    cellOptions: {
                        format: (item: PredefinedComment) =>
                            item.active
                                ? t('settings.devices.predefined-comments.status.active')
                                : t('settings.devices.predefined-comments.status.inactive'),
                    },
                },
            },
        ],
    });

    return { getDefaultConfig };
};
